'use client';
// libs
import { createContext } from 'react';
import { INITIAL_CONTEXT } from './initial-context.constant';

export const DialogContext = createContext<unknown>(INITIAL_CONTEXT);

export default DialogContext;
